class FreeGiftManager extends HTMLElement {
  constructor() {
    super();
    this.boundCheckCart = this.checkCart.bind(this);
    this.boundHandleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  connectedCallback() {
    this.checkboxConsent = this.querySelector('[data-free-gift-checkbox], #free_gift');
    this.shopifyAjaxCartURL = `${window.routes.cart}.js`;
    this.targetPrice = Number(window.theme?.thresholdGift || 0) * 100;
    this.freeGift = window.theme?.freeGift;
    this.offerContainer = this.querySelector('.free-sample-offer');
    this.statusElement = this.querySelector('[data-free-gift-status]');
    this.freeGiftPropertyKey = '_free_gift';

    if (typeof this.targetPrice !== 'number' || !this.freeGift || this.targetPrice <= 0) {
      this.hideOffer();
      this.setStatus('Configuration echantillon incomplete.', true);
      return;
    }

    this.checkCart();
    document.addEventListener('cart-update', this.boundCheckCart);
    document.documentElement.addEventListener('theme:cartchanged', this.boundCheckCart);
  }

  disconnectedCallback() {
    document.removeEventListener('cart-update', this.boundCheckCart);
    document.documentElement.removeEventListener('theme:cartchanged', this.boundCheckCart);
    this.checkboxConsent?.removeEventListener('change', this.boundHandleCheckboxChange);
  }

  checkCart() {
    this.getCart((cartDataJSON) => {
      const cartTotal = cartDataJSON.total_price;
      const items = cartDataJSON.items;
      const freeGiftInCart = this.findFreeGift(items);
      const canShowOffer = cartTotal >= this.targetPrice;

      this.toggleOffer(canShowOffer);
      this.syncCheckbox(freeGiftInCart, canShowOffer);
      this.ensureCheckboxListener();
      this.setStatus('');

      if (freeGiftInCart && freeGiftInCart.quantity > 1) {
        this.updateGift(freeGiftInCart.key, 1);
        return;
      }

      if (freeGiftInCart && !canShowOffer) {
        this.updateGift(freeGiftInCart.key, 0);
      }
    });
  }

  ensureCheckboxListener() {
    if (this.checkboxConsent === null) return;

    this.checkboxConsent.removeEventListener('change', this.boundHandleCheckboxChange);
    this.checkboxConsent.addEventListener('change', this.boundHandleCheckboxChange);
  }

  handleCheckboxChange() {
    if (this.checkboxConsent === null) return;

    this.getCart((cartDataJSON) => {
      const cartTotal = cartDataJSON.total_price;
      const items = cartDataJSON.items;
      const freeGiftInCart = this.findFreeGift(items);
      const canShowOffer = cartTotal >= this.targetPrice;

      if (!canShowOffer) {
        this.checkboxConsent.checked = false;
        this.toggleOffer(false);
        this.setStatus('Palier non atteint.', true);
        if (freeGiftInCart) {
          this.updateGift(freeGiftInCart.key, 0);
        }
        return;
      }

      if (this.checkboxConsent.checked) {
        if (!freeGiftInCart) {
          this.setStatus('Ajout de l\'echantillon...');
          this.addToCart(1);
        }
      } else if (freeGiftInCart) {
        this.setStatus('Retrait de l\'echantillon...');
        this.updateGift(freeGiftInCart.key, 0);
      }
    });
  }

  getCart(callback) {
    $.get(this.shopifyAjaxCartURL, (cartData) => {
      const cartDataJSON = $.parseJSON(cartData);
      callback(cartDataJSON);
    }, 'html');
  }

  findFreeGift(items) {
    for (let index = 0; index < items.length; index += 1) {
      const item = items[index];
      const hasFreeGiftProperty =
        item.properties &&
        (item.properties[this.freeGiftPropertyKey] === true ||
          item.properties[this.freeGiftPropertyKey] === 'true');

      if (hasFreeGiftProperty) {
        return {
          ...item
        };
      }
    }

    return null;
  }

  addToCart(quantity) {
    if (!this.freeGift.available) return;

    const data = {
      quantity,
      id: this.freeGift.id,
      properties: {
        [this.freeGiftPropertyKey]: true
      }
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data,
      dataType: 'json',
      success: () => {
        this.setStatus('Echantillon ajoute.');
        this.refreshCart();
      },
      error: (xhr) => {
        this.setStatus(this.extractErrorMessage(xhr, 'Ajout impossible.'), true);
        console.error('Failed to add item to cart', xhr);
      }
    });
  }

  updateGift(itemKey, quantity) {
    const data = {
      id: itemKey,
      quantity
    };

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data,
      dataType: 'json',
      success: () => {
        this.setStatus('');
        this.refreshCart();
      },
      error: (xhr) => {
        this.setStatus(this.extractErrorMessage(xhr, 'Mise a jour impossible.'), true);
        console.error('Failed to update item in cart', xhr);
      }
    });
  }

  refreshCart() {
    Shopify.getCart((cart) => {
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      } else if (window.sharedFunctions?.updateSidebarCart && document.body.classList.contains('cart-sidebar-show')) {
        window.sharedFunctions.updateSidebarCart(cart);
      }

      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged'));
    });
  }

  toggleOffer(shouldShow) {
    if (!this.offerContainer) return;

    this.offerContainer.classList.toggle('is-hidden', !shouldShow);

    if (!shouldShow && this.checkboxConsent) {
      this.checkboxConsent.checked = false;
    }
  }

  hideOffer() {
    this.toggleOffer(false);
  }

  syncCheckbox(freeGiftInCart, canShowOffer) {
    if (!this.checkboxConsent) return;

    this.checkboxConsent.checked = Boolean(freeGiftInCart);
    this.checkboxConsent.disabled = !canShowOffer;
  }

  setStatus(message, isError = false) {
    if (!this.statusElement) return;

    this.statusElement.textContent = message || '';
    this.statusElement.classList.toggle('is-error', isError);
  }

  extractErrorMessage(xhr, fallbackMessage) {
    if (!xhr) return fallbackMessage;

    if (xhr.responseJSON?.description) return xhr.responseJSON.description;
    if (xhr.responseJSON?.message) return xhr.responseJSON.message;

    try {
      const parsed = JSON.parse(xhr.responseText);
      if (parsed?.description) return parsed.description;
      if (parsed?.message) return parsed.message;
    } catch (error) {
      // Keep fallback message when response is not JSON.
    }

    return fallbackMessage;
  }
}

customElements.get('free-gift') || customElements.define('free-gift', FreeGiftManager);
